/**
 * Slug-based cell renderer override for order::side columns.
 * Displays the side value with an info icon for MULTI orders that triggers the legs hover card.
 */
import { registerSlugCellRenderer } from './index';
import type { SlugCellRendererDefinition } from './index';
import { Slugs } from '@thinkalpha/common/constants/slugs.js';
import { makeCellRenderer } from 'src/features/clientColumns/orderSide/makeCellRenderer';

/**
 * Slug cell renderer definition for order::side.
 * Overrides the default rendering to show MULTI orders with a hover card icon.
 */
export const orderSideSlugRendererDefinition: SlugCellRendererDefinition = {
    slug: Slugs.orderSide,
    requiredSlugs: [Slugs.orderSide, Slugs.orderClOrdId],
    createCellRenderer: ({ resolvedFieldIds }) =>
        makeCellRenderer({
            sideFieldId: resolvedFieldIds[Slugs.orderSide] ?? '',
            clOrdIdFieldId: resolvedFieldIds[Slugs.orderClOrdId] ?? '',
        }),
};

/**
 * Register the order::side slug cell renderer.
 * This should be called during application initialization.
 */
export function registerOrderSideSlugRenderer(): void {
    registerSlugCellRenderer(orderSideSlugRendererDefinition);
}
